"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselSliderImage = exports.CarouselSliderDetails = exports.CarouselSliderArrow = exports.CarouselSlider = exports.CarouselHeroImage = exports.CarouselHeroDetails = exports.CarouselHero = exports.Carousel = void 0;
require("core-js/modules/es.array.sort.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _pixelated = require("../utilities/pixelated.api");
var _pixelated2 = require("../utilities/pixelated.functions");
require("./pixelated.carousel.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const divSelector = 'div.carousel-slider-container';
const tx100 = 'translateX(100%)';
const tx0 = 'translateX(0%)';
const txn100 = 'translateX(-100%)';

/* https://dev.to/willamesoares/how-to-build-an-image-carousel-with-react--24na */

/* ========== CAROUSEL ========== */
class Carousel extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      flickr: {
        baseURL: 'https://api.flickr.com/services/rest/?',
        urlProps: {
          method: 'flickr.photos.search',
          api_key: '882cab5548d53c9e6b5fb24d59cc321d',
          user_id: '15473210@N04',
          tags: 'pixelatedviewsgallery',
          extras: 'date_taken,description,owner_name',
          sort: 'date-taken-desc',
          per_page: 500,
          format: 'json',
          photoSize: 'Medium',
          nojsoncallback: 'true' /*,
                                 startPos: 0 */
        }
      },

      images: {},
      flickrSize: '',
      type: 'slider'
    };
    this.state.flickr = (0, _pixelated2.mergeDeep)(this.state.flickr, this.props.flickr);
    if (this.props.type) {
      this.state.type = this.props.type;
    }
  }
  componentDidMount() {
    this.setState({
      flickrSize: this.flickrSize(this.state.flickr.urlProps.photoSize)
    });
    const myURL = (0, _pixelated.generateURL)(this.state.flickr.baseURL, this.state.flickr.urlProps);
    const myMethod = 'GET';
    (0, _pixelated.getXHRData)(myURL, myMethod, flickrPhotos => {
      const myFlickrImages = flickrPhotos.photos.photo;
      // FIX FOR FLICKR API SORT BUG
      myFlickrImages.sort((a, b) => {
        return new Date(b.datetaken) - new Date(a.datetaken);
      }); // b - a for reverse sort
      this.setState({
        images: myFlickrImages
      });
    });
  }
  flickrSize(size) {
    switch (size) {
      case 'Square':
        return '_s';
      // 75
      case 'Large Square':
        return '_q';
      // 150
      case 'Thumbnail':
        return '_t';
      // 100
      case 'Small':
        return '_m';
      // 240
      case 'Small 320':
        return '_n';
      // 320
      case 'Medium':
        return '';
      // 500
      case 'Medium 640':
        return '_z';
      // 640
      case 'Medium 800':
        return '_c';
      // 800
      case 'Large':
        return '_b';
      // 1024
      // case "Large2" : return "_h"; // 1600 + secret
      // case "Large3" : return "_k"; // 2048 + secret
      // case "XL3K" : return "_3k"; // 3072 + secret
      // case "XL4K" : return "_4k"; // 4096 + secret
      // case "XLF" : return "_f"; // 4096 + secret - only 2:1 aspect ratio
      // case "XL5K" : return "_5k"; // 5120 + secret
      // case "XL6K" : return "_6k"; // 6144 + secret
      // case "Original" : return "_o"; // secret + EXIF data; not rotated, ? ext
      default:
        return '';
    }
  }
  render() {
    if (this.state.type === 'slider') {
      return /*#__PURE__*/_react.default.createElement(CarouselSlider, {
        flickrData: this.state
      });
    } else if (this.state.type === 'hero') {
      return /*#__PURE__*/_react.default.createElement(CarouselHero, {
        flickrData: this.state
      });
    } else {
      return null;
    }
  }
}

/* ========== CAROUSEL SLIDER ========== */
exports.Carousel = Carousel;
/* Not using defaultProps as they are merged shallow, not deep
 https://stackoverflow.com/questions/40428847/react-component-defaultprops-objects-are-overridden-not-merged */
_defineProperty(Carousel, "propTypes", {
  flickr: _propTypes.default.object,
  type: _propTypes.default.string
});
class CarouselSlider extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "previousImage", () => {
      if (this.state.activeIndex === 0) {
        this.setState({
          activeIndex: this.props.flickrData.images.length - 1,
          direction: 'prev'
        });
      } else {
        this.setState({
          activeIndex: this.state.activeIndex - 1,
          direction: 'prev'
        });
      }
    });
    _defineProperty(this, "nextImage", () => {
      if (this.state.activeIndex === this.props.flickrData.images.length - 1) {
        this.setState({
          activeIndex: 0,
          direction: 'next'
        });
      } else {
        this.setState({
          activeIndex: this.state.activeIndex + 1,
          direction: 'next'
        });
      }
    });
    _defineProperty(this, "animate", elem => {
      // eslint-disable-next-line no-undef
      requestAnimationFrame(this.animate);
      elem.style.left = this.drag.newX + this.drag.momentumX + 'px';
      return true;
    });
    /* https://gist.github.com/hartzis/b34a4beeb5ceb4bf1ed8659e477c4191
     https://www.kirupa.com/html5/drag.htm */
    _defineProperty(this, "dragStart", e => {
      if (this.drag.debug) {
        console.log('Drag Start - ' + e.type);
      }
      // var elem = e.currentTarget ;
      if (typeof e.target.className === 'string' && (e.target.className.includes('carousel-slider-container') || e.target.className.includes('carousel-slider-image'))) {
        e.preventDefault();
        e.stopPropagation();
        const elem = e.target.closest(divSelector);
        this.drag.draggable = true;
        this.drag.eType = e.type;
        this.drag.firstX = Math.round(this.drag.eType === 'touchstart' ? e.touches[0].pageX : e.pageX);
        this.drag.previousX = this.drag.firstX;
        this.drag.currentX = this.drag.firstX;
        this.drag.startX = elem.offsetLeft;
        /* Add existing drag styles to array - save for later */
        this.drag.dragStyles.transform = elem.style.transform;
        this.drag.dragStyles.transition = elem.style.transition;
        if (e.dataTransfer) {
          e.dataTransfer.setData('text/plain', e.currentTarget.id);
          // eslint-disable-next-line no-undef
          const img = new Image();
          // http://probablyprogramming.com/2009/03/15/the-tiniest-gif-ever
          img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACwAAAAAAQABAAACAkQBADs=';
          e.dataTransfer.setDragImage(img, 0, 0);
        }
        if (this.drag.debug) {
          console.log(JSON.stringify(this.drag));
        }
      }
    });
    _defineProperty(this, "draggable", e => {
      this.drag.dragMoving = true;
      if (this.drag.draggable) {
        e.preventDefault();
        e.stopPropagation();
        const elem = e.target.closest(divSelector);
        this.drag.eType = e.type;
        this.drag.previousX = this.drag.currentX;
        this.drag.currentX = Math.round(this.drag.eType === 'touchmove' ? e.touches[0].pageX : e.pageX);
        /* Set Momentum to max value */
        const _momentumX = Math.round(Math.abs(this.drag.previousX - this.drag.currentX));
        this.drag.momentumX = _momentumX > this.drag.momentumX ? _momentumX : this.drag.momentumX;
        this.drag.moveX = Math.round(Math.abs(this.drag.firstX - this.drag.currentX));
        /* Right to Left or Left to Right */
        this.drag.directionX = this.drag.firstX > this.drag.currentX ? -1 : 1;
        this.drag.newX = this.drag.startX + this.drag.moveX * this.drag.directionX;
        if (this.drag.debug) {
          console.log(JSON.stringify(this.drag));
        }
        elem.style.left = this.drag.newX + 'px';
        /* Remove styles that conflict with dragging */
        elem.style.transition = '';
        elem.style.transform = '';
      }
    });
    _defineProperty(this, "dragEnd", e => {
      if (!this.drag.dragMoving) {
        const thisImg = this.props.flickrData.images[this.state.activeIndex];
        const thisImgURL = 'https://farm' + thisImg.farm + '.static.flickr.com/' + thisImg.server + '/' + thisImg.id + '_' + thisImg.secret + '_b.jpg';
        // var thisImgURL2 =  "http://flickr.com/photo.gne?id=" + thisImg.id + "_" + thisImg.secret  + ".jpg" ;
        window.open(thisImgURL, '_blank');
      }
      if (this.drag.draggable) {
        if (this.drag.debug) {
          console.log('Drag End - ' + e.type);
        }
        const elem = e.target.closest(divSelector);

        /* Add styles back */
        for (const property in this.drag.dragStyles) {
          elem.style[property] = this.drag.dragStyles[property];
        }

        /* Determine drag distance */
        this.drag.eType = e.type;
        this.drag.previousX = this.drag.currentX;
        this.drag.currentX = Math.round(this.drag.eType === 'touchend' ? e.changedTouches[0].pageX : e.pageX);
        this.drag.moveX = Math.round(Math.abs(this.drag.firstX - this.drag.currentX));
        const farEnough = this.drag.moveX > this.drag.minDistance;

        /* Add momentum at the end of the slide */
        elem.style.transition = 'all 0.5s ease-out 0.0s'; /* ease-in */
        elem.style.transform = 'translateX(' + (this.drag.newX + this.drag.momentumX) * this.drag.directionX + ')';

        /* roll in the next / previous image */
        if (farEnough && this.drag.directionX !== 0) {
          this.drag.directionX < 0 ? this.nextImage() : this.previousImage();
        }
        if (this.drag.debug) {
          console.log(JSON.stringify(this.drag));
        }

        /* Reset drag variables */
        this.drag.draggable = false;
        this.drag.dragMoving = false;
        this.drag.eType = null;
        this.drag.startX = 0;
        this.drag.firstX = 0;
        this.drag.previousX = 0;
        this.drag.currentX = null;
        this.drag.momentumX = 0;
        this.drag.moveX = 0;
        this.drag.newX = 0;
        this.drag.dragStyles = {};

        // e.preventDefault();
      }
    });
    _defineProperty(this, "transitionEnd", e => {
      if (this.drag.debug) {
        console.log('Transition End - ' + e.type);
      }
      const elem = e.target;
      if (elem.matches(divSelector)) {
        elem.style.left = '0px';
      }
    });
    this.state = {
      activeIndex: 0,
      direction: 'next'
    };
    this.drag = {
      draggable: false,
      dragMoving: false,
      eType: null,
      startX: 0,
      /* start left of object */
      firstX: 0,
      /* first mouse x */
      previousX: 0,
      /* prevous mouse x */
      currentX: 0,
      /* current mouse x */
      directionX: 0,
      momentumX: 0,
      /* maximum diff of current and previous */
      moveX: 0,
      /* total mouse x distance */
      newX: 0,
      /* new left of object */
      minDistance: 50,
      dragStyles: {},
      debug: false
    };
  }
  componentDidMount() {
    document.addEventListener('touchstart', this.dragStart, {
      passive: false
    });
    document.addEventListener('touchmove', this.draggable, {
      passive: false
    });
    document.addEventListener('touchend', this.dragEnd, {
      passive: true
    });
    document.addEventListener('mousedown', this.dragStart, {
      passive: false
    });
    document.addEventListener('mousemove', this.draggable, {
      passive: false
    });
    document.addEventListener('mouseup', this.dragEnd, {
      passive: true
    });
    document.addEventListener('transitionend', this.transitionEnd, {
      passive: true
    });
  }
  componentWillUnmount() {
    document.removeEventListener('touchstart', this.dragStart, {
      passive: false
    });
    document.removeEventListener('touchmove', this.draggable, {
      passive: false
    });
    document.removeEventListener('touchend', this.dragEnd, {
      passive: true
    });
    document.removeEventListener('mousedown', this.dragStart, {
      passive: false
    });
    document.removeEventListener('mousemove', this.draggable, {
      passive: false
    });
    document.removeEventListener('mouseup', this.dragEnd, {
      passive: true
    });
    document.removeEventListener('transitionend', this.transitionEnd, {
      passive: true
    });
  }
  render() {
    if (this.props.flickrData.images.length > 0) {
      const myActiveIndex = this.state.activeIndex;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "section-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "carousel-container"
      }, /*#__PURE__*/_react.default.createElement(CarouselSliderArrow, {
        direction: "left",
        clickFunction: this.previousImage,
        glyph: "\u25C0"
      }), this.props.flickrData.images.map((image, i) => /*#__PURE__*/_react.default.createElement(CarouselSliderImage, {
        key: image.id,
        direction: this.state.direction,
        activeIndex: myActiveIndex,
        index: i,
        imagesLength: this.props.flickrData.images.length,
        image: image,
        size: this.props.flickrData.flickrSize
      })), /*#__PURE__*/_react.default.createElement(CarouselSliderArrow, {
        direction: "right",
        clickFunction: this.nextImage,
        glyph: "\u25B6"
      }), /*#__PURE__*/_react.default.createElement(CarouselSliderDetails, {
        index: this.state.activeIndex + 1,
        length: this.props.flickrData.images.length,
        image: this.props.flickrData.images[myActiveIndex]
      })));
    } else {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "carousel"
      });
    }
  }
}

/* ========== CAROUSEL SLIDER IMAGE ========== */
exports.CarouselSlider = CarouselSlider;
_defineProperty(CarouselSlider, "propTypes", {
  flickrData: _propTypes.default.object.isRequired
});
class CarouselSliderImage extends _react.Component {
  constructor(props) {
    super(props);
    this.myImage = /*#__PURE__*/_react.default.createRef();
    this.state = {};
  }
  render() {
    const myImg = this.props.image;
    const myZindex = this.props.imagesLength - this.props.index;
    const styles = {
      zIndex: myZindex /* ,
                       left: '0px' */
    };

    // if (this.props.direction === 'next') {
    /* Use transition all instead of transform to affect left property */
    styles.transition = 'all 1.0s ease 0.1s'; /* ease-in */
    // } else if (this.props.direction === 'prev') {
    // styles.transition = 'all 1.0s ease 0.1s'; /* ease-out */
    // }
    if (this.props.index > this.props.activeIndex) {
      styles.transform = tx100;
      /* styles.msTransform = tx100;
         styles.WebkitTransform = tx100; */
    } else if (this.props.index === this.props.activeIndex) {
      styles.transform = tx0;
      /* styles.msTransform = tx0;
         styles.WebkitTransform = tx0; */
    } else if (this.props.index < this.props.activeIndex) {
      styles.transform = txn100;
      /* styles.msTransform = txn100;
         styles.WebkitTransform = txn100; */
    }

    return /*#__PURE__*/_react.default.createElement("div", {
      id: 'c-' + myImg.id,
      className: "carousel-slider-container",
      style: styles,
      draggable: "true"
    }, /*#__PURE__*/_react.default.createElement("img", {
      className: "carousel-slider-image",
      draggable: "false",
      src: 'https://farm' + myImg.farm + '.static.flickr.com/' + myImg.server + '/' + myImg.id + '_' + myImg.secret + this.props.size + '.jpg',
      id: myImg.id,
      alt: myImg.title,
      title: myImg.title
    }));
  }
}

/* ========== CAROUSEL SLIDER DETAILS ========== */
exports.CarouselSliderImage = CarouselSliderImage;
_defineProperty(CarouselSliderImage, "propTypes", {
  direction: _propTypes.default.string.isRequired,
  activeIndex: _propTypes.default.number.isRequired,
  index: _propTypes.default.number.isRequired,
  imagesLength: _propTypes.default.number.isRequired,
  image: _propTypes.default.object.isRequired,
  size: _propTypes.default.string.isRequired
});
class CarouselSliderDetails extends _react.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "carousel-slider-details text-outline-halo"
    }, this.props.index, " of ", this.props.length, " - ", this.props.image.title, " ", /*#__PURE__*/_react.default.createElement("br", null), "by ", this.props.image.ownername, " on ", this.props.image.datetaken);
  }
}

/* ========== CAROUSEL SLIDER ARROW ========== */
exports.CarouselSliderDetails = CarouselSliderDetails;
_defineProperty(CarouselSliderDetails, "propTypes", {
  index: _propTypes.default.number.isRequired,
  length: _propTypes.default.number.isRequired,
  image: _propTypes.default.object.isRequired
});
class CarouselSliderArrow extends _react.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: 'carousel-arrow text-outline-halo ' + this.props.direction,
      onClick: this.props.clickFunction
    }, this.props.glyph);
  }
}

/* ========== CAROUSEL HERO ========== */
exports.CarouselSliderArrow = CarouselSliderArrow;
_defineProperty(CarouselSliderArrow, "propTypes", {
  direction: _propTypes.default.string.isRequired,
  clickFunction: _propTypes.default.func.isRequired,
  glyph: _propTypes.default.string.isRequired
});
class CarouselHero extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "nextImage", () => {
      if (this.state.activeIndex === this.props.flickrData.images.length - 1) {
        this.setState({
          activeIndex: 0,
          direction: this.state.direction === 'up' ? 'down' : 'up'
        });
      } else {
        this.setState({
          activeIndex: this.state.activeIndex + 1,
          direction: this.state.direction === 'up' ? 'down' : 'up'
        });
      }
    });
    this.debug = false;
    this.state = {
      activeIndex: 0,
      direction: 'up',
      timeout: 5000
    };
    if (this.props.flickrData) {
      this.state = (0, _pixelated2.mergeDeep)(this.state, this.props.flickrData);
    }
  }
  render() {
    if (this.props.flickrData.images.length > 0) {
      if (this.state.timeout > 0) {
        setTimeout(function () {
          this.nextImage();
        }.bind(this), this.state.timeout);
      }
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, this.props.flickrData.images.map((image, i) => /*#__PURE__*/_react.default.createElement(CarouselHeroImage, {
        key: image.id,
        direction: this.state.direction,
        activeIndex: this.state.activeIndex,
        index: i,
        imagesLength: this.props.flickrData.images.length,
        image: image,
        size: this.props.flickrData.flickrSize
      })), /*#__PURE__*/_react.default.createElement(CarouselHeroDetails, {
        index: this.state.activeIndex + 1,
        length: this.props.flickrData.images.length,
        image: this.props.flickrData.images[this.state.activeIndex]
      }));
    } else {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "carousel"
      });
    }
  }
}

/* ========== CAROUSEL HERO IMAGE ========== */
exports.CarouselHero = CarouselHero;
_defineProperty(CarouselHero, "propTypes", {
  flickrData: _propTypes.default.object.isRequired
});
class CarouselHeroImage extends _react.Component {
  render() {
    const myImg = this.props.image;
    const myZindex = this.props.imagesLength - this.props.index;
    const styles = {
      zIndex: myZindex
    };
    let classes = 'carousel-hero-image';
    if (this.props.index > this.props.activeIndex) {
      classes += ' carousel-hero-hidden';
    } else if (this.props.index === this.props.activeIndex - 1) {
      classes += ' carousel-hero-hide';
    } else if (this.props.index === this.props.activeIndex) {
      classes += ' carousel-hero-visible';
    } else if (this.props.index < this.props.activeIndex) {
      classes += ' carousel-hero-hidden';
    }
    return /*#__PURE__*/_react.default.createElement("img", {
      className: classes,
      style: styles,
      src: 'https://farm' + myImg.farm + '.static.flickr.com/' + myImg.server + '/' + myImg.id + '_' + myImg.secret + this.props.size + '.jpg',
      alt: myImg.title,
      title: myImg.title
    });
  }
}

/* ========== CAROUSEL HERO DETAILS ========== */
exports.CarouselHeroImage = CarouselHeroImage;
_defineProperty(CarouselHeroImage, "propTypes", {
  direction: _propTypes.default.string.isRequired,
  activeIndex: _propTypes.default.number.isRequired,
  index: _propTypes.default.number.isRequired,
  imagesLength: _propTypes.default.number.isRequired,
  image: _propTypes.default.object.isRequired,
  size: _propTypes.default.string.isRequired
});
class CarouselHeroDetails extends _react.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "section-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "carousel-hero-details text-outline-halo"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "carousel-hero-details-left"
    }, /*#__PURE__*/_react.default.createElement("div", null, this.props.index, " of ", this.props.length), /*#__PURE__*/_react.default.createElement("div", null, this.props.image.title)), /*#__PURE__*/_react.default.createElement("div", {
      className: "carousel-hero-details-right"
    }, /*#__PURE__*/_react.default.createElement("div", null, "by ", this.props.image.ownername), /*#__PURE__*/_react.default.createElement("div", null, this.props.image.datetaken))));
  }
}
exports.CarouselHeroDetails = CarouselHeroDetails;
_defineProperty(CarouselHeroDetails, "propTypes", {
  index: _propTypes.default.number.isRequired,
  length: _propTypes.default.number.isRequired,
  image: _propTypes.default.object.isRequired
});